import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import React from 'react';

const MentionNodeView = ({ node }) => {
    return (
        <NodeViewWrapper as="span" style={{ display: 'inline-block' }}>
            <span className="mention-pill" data-uid={node.attrs.uid} data-avatar={node.attrs.avatar} contentEditable="false" suppressContentEditableWarning>
                {node.attrs.avatar && (
                    <span className="mention-avatar" style={{ backgroundImage: `url('${node.attrs.avatar}')` }}></span>
                )}
                <span className="mention-name">{node.attrs.name}</span>
            </span>
        </NodeViewWrapper>
    );
};

export const MentionExtension = Node.create({
    name: 'mentionBlock',
    priority: 1000,
    group: 'inline',
    inline: true,
    atom: true,

    // Integración main→dev, epic D2: `data-*` para round-trip en save+reload.
    addAttributes() {
        return {
            uid: {
                default: null,
                parseHTML: (e) => e.getAttribute('data-uid'),
                renderHTML: (a) => (a.uid ? { 'data-uid': a.uid } : {}),
            },
            name: {
                default: '',
                parseHTML: (e) => e.getAttribute('data-name') || e.querySelector('.mention-name')?.textContent || '',
                renderHTML: (a) => (a.name ? { 'data-name': a.name } : {}),
            },
            avatar: {
                default: null,
                parseHTML: (e) => e.getAttribute('data-avatar'),
                renderHTML: (a) => (a.avatar ? { 'data-avatar': a.avatar } : {}),
            },
        };
    },

    parseHTML() {
        return [{ tag: 'span.mention-pill' }];
    },

    renderHTML({ HTMLAttributes }) {
        return ['span', mergeAttributes({ class: 'mention-pill' }, HTMLAttributes)];
    },

    renderText({ node }) {
        return `@${node.attrs.name || 'usuario'}`;
    },

    addNodeView() {
        return ReactNodeViewRenderer(MentionNodeView);
    },
});
